export const cpInPersonVisitRoute = [
    '08171',
    '08172',
    '08173',
    '08174',
    '08190',
    '08191',
    '08192',
    '08193',
    '08194',
    '08194',
    '08194',
    '08195',
    '08196',
    '08197',
    '08198',
    '08199',
    '08199',
    '08220',
    '08221',
    '08223',
    '08224',
    '08228',
    '08228',
    '08231',
    '08232',
    '08233',
    '08255',
    '08255',
    '08275',
    '08281',
    '08289',
    '08289',
    '08292',
    '08292',
    '08293',
    '08294',
    '08294',
    '08298',
    '08630',
    '08630',
    '08635',
    '08640',
    '08700',
    '08710',
    '08710',
    '08711',
    '08711',
    '08711',
    '08712',
    '08717',
    '08717',
    '08719',
    '08719',
    '08719',
    '08719',
    '08740',
    '08750',
    '08750',
    '08750',
    '08750',
    '08753',
    '08754',
    '08755',
    '08756',
    '08757',
    '08757',
    '08757',
    '08758',
    '08760',
    '08761',
    '08761',
    '08769',
    '08780',
    '08781',
    '08781',
    '08782',
    '08782',
    '08783',
    '08784',
    '08785',
    '08786',
    '08787',
    '08787',
    '08787',
    '08787',
    '08787',
    '08788',
    '08789',
    '08789',
    '08789',
    '08790',
    '08790',
    '08790',
    '08791',
    '25130',
    '25143',
    '25144',
    '25200',
    '25211',
    '25211',
    '25211',
    '25211',
    '25212',
    '25212',
    '25310',
    '25315',
    '25315',
    '25315',
    '25316',
    '25316',
    '25316',
    '25317',
    '25317',
    '25317',
    '25317',
    '25318',
    '25318',
    '25318',
    '25318',
    '25318',
    '25318',
    '25318',
    '25318',
    '25331',
    '25331',
    '25334',
    '25335',
    '25335',
    '25335',
    '25336',
    '25337',
    '25337',
    '25353',
    '25354',
    '25355',
    '25600',
    '25600',
    '25613',
    '25613',
    '25614',
    '25616',
    '25617',
    '25617',
    '25617',
    '25617',
    '25680',
    '25737',
    '25737',
    '25739',
    '25739',
    '25739',
    '25749',
    '25749'
];